import { recentCitiesCookieSelector, recentCitiesSelector } from 'app/store/selectors';
import { AppDispatch, RootState } from 'app/hooks/appHooks';
import { AutocompleteResult, SearchMaskDirection } from 'app/models/types/store/location';
import { retrieveRecentCities } from './retrieveRecentCitiesThunk';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setCookieForDomain } from 'app/functions/general/setCookieForDomain';

export type StoreRecentCityType = {
  direction: SearchMaskDirection;
  city: Pick<AutocompleteResult, 'id' | 'name' | 'legacyId'>;
};

export const storeRecentCity = createAsyncThunk<
  void,
  StoreRecentCityType,
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>('location/retrieveRecentCities', async ({ direction, city }, { dispatch, getState }) => {
  const state = getState();
  const cookies: { from: string; to: string } = recentCitiesCookieSelector(state);
  const recentCities: ReturnType<typeof recentCitiesSelector> = recentCitiesSelector(state);
  const newCities = [
    { id: city.id, name: city.name },
    ...recentCities[direction]
      .filter(({ id }) => id !== city.id)
      .map(({ id, name }) => ({ id, name })),
  ];
  setCookieForDomain({
    cookieName: cookies[direction],
    cookieValue: JSON.stringify(newCities.slice(0, 5)),
    expirationTime: 365,
  });

  await dispatch(retrieveRecentCities());
});
